<template>
  <v-card height="256px">
    <v-container fluid>
      <v-row no-gutters>
        <v-col>
          <h2 class="title">Tiempo promedio de servicio</h2>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col class="pl-5 pr-5">
          <v-row justify="center" align="center">
            <v-col cols="6" class="text-left mt-0 pt-0">
              <span class="body-2">Servicios en taller</span>
              <br />
              <span class="headline">Correctivos</span>
              <br />
              <span class="headline">Preventivos</span>
            </v-col>
            <v-col cols="6" class="text-right mt-0 pt-0">
              <br />
              <span class="headline red--text"
                >{{ averageCorrectiveWorkshop }}
                {{ daysValidation(averageCorrectiveWorkshop) }}</span
              >
              <br />
              <span class="headline red--text"
                >{{ averagePreventiveWorkshop }}
                {{ daysValidation(averagePreventiveWorkshop) }}</span
              >
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col cols="6" class="text-left mt-0 pt-0">
              <span class="body-2">Servicios en obra</span>
              <br />
              <span class="headline">Correctivos</span>
              <br />
              <span class="headline">Preventivos</span>
            </v-col>
            <v-col cols="6" class="text-right mt-0 pt-0">
              <br />
              <span class="headline red--text"
                >{{ averageCorrectiveWork }}
                {{ daysValidation(averageCorrectiveWork) }}</span
              >
              <br />
              <span class="headline red--text"
                >{{ averagePreventiveWork }}
                {{ daysValidation(averagePreventiveWork) }}</span
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  mounted() {
    if (this.$route.params.branchOffice) {
      this.getAverageServiceTime({
        place: "Obra",
        type: "Preventivo",
        branch: this.$route.params.branchOffice
      });
      this.getAverageServiceTime({
        place: "Obra",
        type: "Correctivo",
        branch: this.$route.params.branchOffice
      });
      this.getAverageServiceTime({
        place: "Taller",
        type: "Preventivo",
        branch: this.$route.params.branchOffice
      });
      this.getAverageServiceTime({
        place: "Taller",
        type: "Correctivo",
        branch: this.$route.params.branchOffice
      });
    } else {
      this.getAverageServiceTime({ place: "Obra", type: "Preventivo" });
      this.getAverageServiceTime({ place: "Obra", type: "Correctivo" });
      this.getAverageServiceTime({ place: "Taller", type: "Preventivo" });
      this.getAverageServiceTime({ place: "Taller", type: "Correctivo" });
    }
  },
  computed: {
    ...mapState("services", [
      "averagePreventiveWork",
      "averageCorrectiveWork",
      "averagePreventiveWorkshop",
      "averageCorrectiveWorkshop"
    ])
  },
  methods: {
    ...mapActions("services", ["getAverageServiceTime"]),
    daysValidation(days) {
      if (days == 1) {
        return "hr";
      } else {
        return "hrs";
      }
    }
  },
  watch: {
    "$route.params.branchOffice": {
      handler: function(branch) {
        if (branch) {
          this.getAverageServiceTime({
            place: "Obra",
            type: "Preventivo",
            branch: branch
          });
          this.getAverageServiceTime({
            place: "Obra",
            type: "Correctivo",
            branch: branch
          });
          this.getAverageServiceTime({
            place: "Taller",
            type: "Preventivo",
            branch: branch
          });
          this.getAverageServiceTime({
            place: "Taller",
            type: "Correctivo",
            branch: branch
          });
        } else {
          this.getAverageServiceTime({ place: "Obra", type: "Preventivo" });
          this.getAverageServiceTime({ place: "Obra", type: "Correctivo" });
          this.getAverageServiceTime({ place: "Taller", type: "Preventivo" });
          this.getAverageServiceTime({ place: "Taller", type: "Correctivo" });
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style lang="css" scoped>
.title {
  font-weight: 400 !important;
  color: black;
  font-size: 16px !important;
}
.headline,
.body-2 {
  font-weight: 300 !important;
  color: #808080;
}
</style>
